<template lang="html">
  <div id="application" v-cloak @click="emitClick()">

    <sw-background
      :loading="loadingBackground"
      :image="background"
      ></sw-background>

    <sw-topbar></sw-topbar>

    <div class="main">
      <router-view :key="$route.path"></router-view>
    </div>

    <sw-rightbar></sw-rightbar>

    <sw-fullscreen></sw-fullscreen>

    <modal
      id="hint"
      name="hint"
      class="hint"
      ref="hint"
      v-if="showHint"
      v-model="showHint"
      size="sm"
      :backdrop="false"
      :transition-duration="1000"
      :header="false"
      :footer="false"
      @close="showModal = false">
      {{ $getTrans('navigation-loading', 'de', 'hint') }}
    </modal>

    <cookie-law theme="blood-orange"
      :buttonText="$getTrans('dismiss', 'de', 'cookiepoliciy')"
      position="bottom"
      transitionName="fade"
      >
      <div slot="message" class="cookie__message">
        {{ $getTrans('message', 'de', 'cookiepoliciy') }}
        <a
          @click.prevent="toggleCookieModal()"
          href="#"
          class="form__toc">{{ $getTrans('learnMore', 'de', 'cookiepoliciy') }}</a>
      </div>
    </cookie-law>

    <div v-if="cookieModalVisible">
      <sw-cookiepolicy
        @closeToc="getChildData()"></sw-cookiepolicy>
    </div>

  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

import Topbar from '@/components/includes/Topbar'
import Rightbar from '@/components/includes/Rightbar'
import Fullscreen from '@/components/modal/Fullscreen'
import Cookiepolicy from '@/components/cookiepolicy/Cookiepolicy'
import Background from '@/components/includes/Background'

import EventBus from '@/eventbus'
import Firebase from 'firebase'
import api from '@/api'

export default {
  name: 'AppContainer',
  data() {
    return {
      showHint: false,
      cookieModalVisible: false,
      region: null,
      navitems: null,
      loadingBackground: false,
      background: null
    }
  },
  components: {
    'sw-rightbar': Rightbar,
    'sw-topbar': Topbar,
    'sw-fullscreen': Fullscreen,
    'sw-cookiepolicy': Cookiepolicy,
    'sw-background': Background,
    CookieLaw
  },
  created: function () {
    // console.log('App.vue')
    window.addEventListener('scroll', this.emitScroll)
  },
  mounted () {
    // console.log('NODE_ENV', process.env.NODE_ENV)
    EventBus.$on('loading-on', this.showLoading)
    EventBus.$on('loading-off', this.hideLoading)

    EventBus.$on('background-loading-on', this.loadingBackgroundOn)
    EventBus.$on('background-loading-off', this.loadingBackgroundOff)
    EventBus.$on('background-image', this.setBackgroundImage)

    api.initFirebase()
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.emitScroll)
  },
  methods: {
    showLoading (data) {
      // console.log('show loading')
      this.showHint = true
    },
    hideLoading (data) {
      // console.log('hide loading')
      this.showHint = false
    },
    emitClick () {
      // console.log('app clicked')
      // send the click event to the child
      EventBus.$emit('showSearch', true)
    },
    emitScroll (event) {
      EventBus.$emit('showSearch', true)
    },
    toggleCookieModal () {
      this.cookieModalVisible = !this.cookieModalVisible
    },
    getChildData () {
      this.toggleCookieModal()
    },
    getRegion () {
      let region = this.$root.$data.region
      if(region) {
        region = `/${region.toLowerCase()}`
      }
      this.region = region
    },
    loadingBackgroundOn() {
      this.loadingBackground = true
    },
    loadingBackgroundOff() {
      this.loadingBackground = false
    },
    setBackgroundImage(bgImage) {
      this.background = bgImage
    }
  }
}
</script>

<style lang="scss">
// Import global custom sass
@import 'sass/main';
</style>



// WEBPACK FOOTER //
// src/App.vue